import { Empty } from 'antd';
import React from 'react';
import getFormatMessage from '../../../locales/get-format-message';

export const getRowPackageLayout = (
  children: React.ReactNode | string | null,
  suffixChildren?: React.ReactNode | null,
  onMouseEnter?: () => void
) => {
  return (
    <div className="table-cell" onMouseEnter={onMouseEnter}>
      <div className="cell-content">{children}</div>
      {suffixChildren}
    </div>
  );
};

export const renderBodyLineTRSlot = (
  children: React.ReactNode,
  colSpan: number
) => {
  return (
    <tr>
      <td colSpan={colSpan}>{children}</td>
    </tr>
  );
};

export const renderEmpty = (emptyText?: string | React.ReactNode) => {
  if (typeof emptyText === 'string' || !emptyText) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={emptyText || getFormatMessage('no_data_available')}
      />
    );
  }
  return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}>{emptyText}</Empty>;
};
